import { render, staticRenderFns } from "./CasePolicyInfo.vue?vue&type=template&id=0eb10484&scoped=true&"
import script from "./CasePolicyInfo.vue?vue&type=script&lang=ts&"
export * from "./CasePolicyInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CasePolicyInfo.vue?vue&type=style&index=0&id=0eb10484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb10484",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VForm,VImg,VTooltip})
